import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type { CombiOpdrachtenSearch } from '../types/CombiOpdrachtenSearch'

export { initialState, createFilters, searchCombiOpdrachten }

const initialState: CombiOpdrachtenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      werkbak: null,
      gebied: [],
      netbeheerder: null,
      aannemer: null,
      search: '',
      searchOption: null,
      fromDate: null,
      toDate: null,
      kpi: '',
      labels: [],
      open: true,
      myList: false,
    },
    sort: { sortBy: 'changed', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  werkbak,
  netbeheerder,
  aannemer,
  gebied,
  search,
  searchOption,
  fromDate,
  toDate,
  kpi,
  labels,
  open,
  myList,
}) => {
  const filters: IFilter[] = []

  if (werkbak)
    filters.push({ name: 'werkbak', value: werkbak.code, operator: 'eq' })
  if (netbeheerder)
    filters.push({ name: 'netbeheerder', value: netbeheerder, operator: 'eq' })
  if (aannemer)
    filters.push({ name: 'aannemer', value: aannemer, operator: 'eq' })
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (search && search !== '') {
    if (searchOption)
      filters.push({ name: searchOption.k, value: search, operator: 'eq' })
    else filters.push({ name: 'text', value: search, operator: 'contains' })
  }
  if (fromDate)
    filters.push({
      name: 'realisatiedatum',
      value: startOfDay(fromDate),
      operator: 'gte',
    })
  if (toDate)
    filters.push({
      name: 'realisatiedatum',
      value: endOfDay(toDate),
      operator: 'lte',
    })
  if (kpi) filters.push({ name: 'kpi.rag', value: kpi, operator: 'eq' })
  if (open) filters.push({ name: 'status', value: 900, operator: 'lt' })
  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  return filters
}

const searchCombiOpdrachten = async ({
  query,
}: {
  query: CombiOpdrachtenSearch['query']
}): Promise<CombiOpdrachtenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/opdracht',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
